<template>
  <div class="ecommerce">
    <Header />
    <PageTitle />
    <div class="page-content">
      <router-view :key="$route.path"></router-view>
    </div>
    <br />
    <Footer />
  </div>
</template>

<script>
import axios from "axios"
import Header from "@/components/Header"
import PageTitle from "@/components/PageTitle"
import Footer from "@/components/Footer"

export default {
  data() {
    return {
      defaultBanner: null,
      isMobileMenu: false
    }
  },
  computed: {
    cart() {
      return this.$store.state.cart
    },
    client() {
      return this.$store.state.currentUser
    },
    bannerImage() {
      if (this.banner && this.banner.image) {
        return "url(" + encodeURI(this.baseUrl + this.banner.image.url) + ")"
      } else {
        return ""
      }
    },
    banner() {
      return this.$store.state.banner
    },
  },
  created() {
    this.setDefaultBanner()
  },
  methods: {
    setDefaultBanner() {
      if (this.defaultBanner) {
        this.$store.dispatch("updateBanner", this.defaultBanner)
      } else {
        axios
          .get("banner/1")
          .then((response) => {
            this.defaultBanner = response.data
            this.$store.dispatch("updateBanner", this.defaultBanner)
          })
          .catch(this.showError)
      }
    },
  },
  watch: {
    $route(to) {
      if (to.path.indexOf("/conteudo/") != 0) {
        this.setDefaultBanner()
      }
    },
  },
  components: {
    Header,
    PageTitle,
    Footer
  }
}
</script>
